import { createReducer, on } from '@ngrx/store'

import { WorkflowBuilderActions } from './workflow-builder.actions'
import {
  onAddInitialMessage,
  onClearMessages,
  onGetResponseFailure,
  onGetResponseStream,
  onGetResponseStreamCompleted,
  onUserSendMessage,
} from './workflow-builder.handler'
import { initialState } from './workflow-builder.state'

export const workflowBuilderReducer = createReducer(
  initialState,
  on(WorkflowBuilderActions.getResponseStream, onGetResponseStream),
  on(WorkflowBuilderActions.sendMessage, onUserSendMessage),
  on(WorkflowBuilderActions.getResponseFailure, onGetResponseFailure),
  on(WorkflowBuilderActions.getResponseStreamCompleted, onGetResponseStreamCompleted),
  on(WorkflowBuilderActions.clearMessages, onClearMessages),
  on(WorkflowBuilderActions.addInitialMessage, onAddInitialMessage)
)
